import getAppliedGiftcards from '../selectors/GiftCardSelectors/getAppliedGiftcards';
import * as types from './action-types';

export default () => (dispatch, getState) => {
  const appliedGiftcardsInState = getAppliedGiftcards(getState());
  if (appliedGiftcardsInState?.length > 0) {
    dispatch({type: types.ADD_APPLIED_GIFTCARD_TO_STATE, updatedAppliedGiftcards: []});
  }
};
